
import DrawBase from "../DrawBase"
import EditPolygon from "./EditPolygon"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawPolygon extends DrawBase {

    constructor(options) {
        super(options);
    }

    getEditInterface() {
        return EditPolygon;
    }

    getTypeName() {
        return "面";
    }

    getType() {
        return "polygon_Nor";
    }

    checkMouseMove() {
        if (this.positionsTemp.length < 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return new $this.Cesium.PolygonHierarchy(positionsArr);
            }
            return new $this.Cesium.PolygonHierarchy(positionsArr ? positionsArr : $this.positions);
        }, false);
        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

    loadDynamicGraph(entity, data) {

        var $this = this;
        var positionsArr = JSON.parse(data.editPositions);
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy(positionsArr);
        }, true);
        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")

    }

}

export default DrawPolygon;